module.exports = __webpack_public_path__ + "img/bloody-mary.d7db2a27.jpg";